import { gql, TypedDocumentNode } from '@common/hooks';
import { WorksClinicalUnitsQueryCgResponse } from '@common/graphql';

export const WORKS_CLINICAL_UNITS_QUERY: TypedDocumentNode<WorksClinicalUnitsQueryCgResponse> = gql`
  query WorksClinicalUnits {
    worksClinicalUnits {
      id
      displayName
    }
  }
`;
